import { ColumnDescription } from "react-bootstrap-table-next";
import { useAtendimentoPage } from "../../../Context/AtendimentoPage";
import {
    AtualizarProponentesVendasController,
    ProponentesVendasController,
    RemoverProponentesVendasController,
} from "../../../Controllers/Vendas/Proponentes/ProponentesController";
import useAsyncEffect from "../../../hooks/useAsyncEffect";
import Table from "../../Table";
import { IListProponentesResponse } from "../../../Interfaces/Vendas/Proponentes/ProponentesInterface";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import {
    faEdit,
    faPlus,
    faSave,
    faTrash,
} from "@fortawesome/free-solid-svg-icons";
import EditarCliente from "../Geral/Cliente/DadosCadastraisCliente/EditarCliente";
import { useState } from "react";
import { IComponentModal } from "../../Modais/IModalComponent";
import ModalComponent from "../../Modais";
import useAsyncCallback from "../../../hooks/useAsyncCallback";
import { GetClienteCompleto } from "../../../Controllers/Geral/GestaoClientes/GestaoClientesController";
import { Spinner } from "../../Loding/SpinnerPadrao";
import PesquisarProponentes from "../../../Pages/Vendas/Proponentes/Proponentes";
import Swal from "sweetalert2";

interface IProponentes {}

export default function Proponentes(props: IProponentes) {
    const { ID_CASO } = useAtendimentoPage();
    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();
    const [errorMessage, setErrorMessage] = useState("");
    const [participacoes, setParticipacoes] = useState<
        Array<{
            ID_CONTA: number;
            VL_PARTICIPACAO: number;
        }>
    >([]);

    const {
        value: lstProponentes,
        loading: lstProponentesLoading,
        execute: ProponentesVendas,
    } = useAsyncEffect(async () => {
        const res = await ProponentesVendasController(ID_CASO);
        setParticipacoes(
            res.map((p) => ({
                ID_CONTA: p.ID_CONTA,
                VL_PARTICIPACAO: p.VL_PARTICIPACAO * 100,
            }))
        );
        return res;
    }, [ID_CASO]);

    const {
        execute: AtualizarProponentesVendas,
        loading: AtualizarProponentesVendasLoading,
    } = useAsyncCallback(AtualizarProponentesVendasController);

    const {
        execute: RemoverProponentesVendas,
        loading: RemoverProponentesVendasLoading,
    } = useAsyncCallback(RemoverProponentesVendasController);

    const salvarPercentual = () => {
        const total = participacoes.reduce(
            (sum, { VL_PARTICIPACAO }) => sum + VL_PARTICIPACAO,
            0
        );

        if (total !== 100) {
            setErrorMessage("A soma das participações deve ser igual a 100%.");
        } else if (participacoes.some((p) => p.VL_PARTICIPACAO === 0)) {
            setErrorMessage(
                "A participação de todos os proponentes deve ser maior que 0%."
            );
        } else {
            setErrorMessage("");

            const vlParticipacao = participacoes.map((p) => ({
                ID_CONTA: p.ID_CONTA,
                VL_PARTICIPACAO: p.VL_PARTICIPACAO / 100,
            }));

            AtualizarProponentesVendas({
                ID_CASO: ID_CASO,
                VL_PARTICIPACAO: vlParticipacao,
            }).then(() => {
                ProponentesVendas();
            });
        }
    };

    const { loading: ClienteLoading, execute: GetCliente } =
        useAsyncCallback(GetClienteCompleto);

    const columns: Array<ColumnDescription<IListProponentesResponse>> = [
        {
            dataField: "DS_NOME",
            text: "Nome",
            headerAlign: "center",
            formatter: (c, row) => {
                return (
                    <div className="d-flex justify-content-center align-items-center">
                        {c}
                    </div>
                );
            },
        },
        {
            dataField: "Fl_PARTICIPANTE_ANALISE_CREDITO",
            text: "Part Análise Créd.?",
            headerAlign: "center",
            formatter: (c, row) => {
                return (
                    <div className="d-flex justify-content-center align-items-center">
                        {c ? "Sim" : "Não"}
                    </div>
                );
            },
        },
        {
            dataField: "VL_PARTICIPACAO",
            text: "Participação (em %)",
            align: "center",
            headerAlign: "center",
            formatter: (c, row, index, errors) => (
                <div className="d-flex justify-content-center align-items-center">
                    <div className="form-group">
                        <div className="input-icon">
                            <span>
                                <i className="fas fa-percent icon-sm"></i>
                            </span>
                            <input
                                type="number"
                                onChange={(e) => {
                                    let value = Number(e.target.value);

                                    value = Math.min(Math.max(value, 0), 100);

                                    setParticipacoes((prevState) => {
                                        const novosValores = [...prevState];

                                        if (index !== -1) {
                                            novosValores[
                                                index
                                            ].VL_PARTICIPACAO = value;
                                        }

                                        return novosValores;
                                    });

                                    e.target.value = value.toString();
                                }}
                                defaultValue={
                                    participacoes[index]?.VL_PARTICIPACAO || 0
                                }
                                className="form-control"
                                max={100}
                                min={0}
                            />
                        </div>
                    </div>
                </div>
            ),
        },
        {
            dataField: "Editar",
            text: "",
            isDummyField: true,
            formatter: (_, row) => (
                <div className="d-flex justify-content-center align-items-center">
                    <OverlayTrigger
                        overlay={<Tooltip id="editar-tooltip">Editar</Tooltip>}
                    >
                        <button
                            className="btn btn-icon btn-outline-primary"
                            onClick={() => {
                                GetCliente(row.ID_CONTA).then((cliente) => {
                                    setShow(true);
                                    setModal({
                                        Children: (
                                            <EditarCliente
                                                Cliente={cliente}
                                                ProponentesVendas={
                                                    ProponentesVendas
                                                }
                                                setShow={setShow}
                                            />
                                        ),
                                        IconHeader: faEdit,
                                        headerComponent: "Editar Proponente",
                                        size: "xl",
                                    });
                                });
                            }}
                            disabled={
                                ClienteLoading ||
                                RemoverProponentesVendasLoading
                            }
                        >
                            {ClienteLoading ||
                            RemoverProponentesVendasLoading ? (
                                <Spinner size="sm" />
                            ) : (
                                <FontAwesomeIcon icon={faEdit} size="lg" />
                            )}
                        </button>
                    </OverlayTrigger>
                </div>
            ),
        },
        {
            dataField: "Excluir",
            text: "",
            isDummyField: true,
            formatter: (_, row) =>
                !row.FL_CLIENTE_PRINCIPAL ? (
                    <div className="d-flex justify-content-center align-items-center">
                        <OverlayTrigger
                            overlay={
                                <Tooltip id="editar-tooltip">Remover</Tooltip>
                            }
                        >
                            <button
                                className="btn btn-icon btn-outline-danger"
                                onClick={() => {
                                    Swal.fire({
                                        title: "Deseja remover este Proponente?",
                                        icon: "question",
                                        buttonsStyling: false,
                                        confirmButtonText:
                                            "<i class='la la-check'></i> Sim!",
                                        showCancelButton: true,
                                        cancelButtonText:
                                            "<i class='la la-thumbs-down'></i> Não",
                                        customClass: {
                                            confirmButton:
                                                "btn btn-outline-success",
                                            cancelButton: "btn btn-default",
                                        },
                                    }).then((result) => {
                                        if (result.isConfirmed) {
                                            RemoverProponentesVendas({
                                                ID_CASO: ID_CASO,
                                                ID_CONTA: row.ID_CONTA,
                                            }).then(() => {
                                                ProponentesVendas();
                                            });
                                        }
                                    });
                                }}
                                disabled={
                                    ClienteLoading ||
                                    RemoverProponentesVendasLoading
                                }
                            >
                                {ClienteLoading ||
                                RemoverProponentesVendasLoading ? (
                                    <Spinner size="lg" />
                                ) : (
                                    <FontAwesomeIcon icon={faTrash} size="lg" />
                                )}
                            </button>
                        </OverlayTrigger>
                    </div>
                ) : (
                    <></>
                ),
        },
        // {
        //     dataField: "Excluir",
        //     text: "",
        //     isDummyField: true,
        //     formatter: (_, row) =>
        //         !row.FL_CLIENTE_PRINCIPAL ? (
        //             <div className="d-flex justify-content-center align-items-center">
        //                 <OverlayTrigger
        //                     overlay={
        //                         <Tooltip id="editar-tooltip">Remover</Tooltip>
        //                     }
        //                 >
        //                     <button
        //                         className="btn btn-icon btn-outline-danger"
        //                         onClick={() => {
        //                             Swal.fire({
        //                                 title: "Deseja remover este Proponente?",
        //                                 icon: "question",
        //                                 buttonsStyling: false,
        //                                 confirmButtonText:
        //                                     "<i class='la la-check'></i> Sim!",
        //                                 showCancelButton: true,
        //                                 cancelButtonText:
        //                                     "<i class='la la-thumbs-down'></i> Não",
        //                                 customClass: {
        //                                     confirmButton:
        //                                         "btn btn-outline-success",
        //                                     cancelButton: "btn btn-default",
        //                                 },
        //                             }).then((result) => {
        //                                 if (result.isConfirmed) {
        //                                     // DeletarProponenteController(
        //                                     //     row.ID_CONTA
        //                                     // ).then(() => {
        //                                     //     ProponentesVendasController(ID_CASO);
        //                                     // });
        //                                 }
        //                             });
        //                         }}
        //                         disabled={ClienteLoading}
        //                     >
        //                         {ClienteLoading ? (
        //                             <Spinner size="lg" />
        //                         ) : (
        //                             <FontAwesomeIcon icon={faTrash} size="lg" />
        //                         )}
        //                     </button>
        //                 </OverlayTrigger>
        //             </div>
        //         ) : (
        //             <></>
        //         ),
        // },
    ];

    return (
        <div className="card card-custom">
            <div className="d-flex flex-column p-6 y-scroll">
                <div className="d-flex justify-content-between align-items-center py-2">
                    <div className="mx-auto text-center">
                        {errorMessage && (
                            <div className="text-danger mt-2">
                                {errorMessage}
                            </div>
                        )}
                    </div>
                    <div>
                        <OverlayTrigger
                            overlay={
                                <Tooltip id="salvar-tooltip">
                                    Salvar Percentual de Participação
                                </Tooltip>
                            }
                        >
                            <button
                                className="btn btn-clean btn-success btn-icon"
                                onClick={salvarPercentual}
                                disabled={AtualizarProponentesVendasLoading}
                            >
                                {AtualizarProponentesVendasLoading ? (
                                    <Spinner size="sm" />
                                ) : (
                                    <FontAwesomeIcon icon={faSave} size="lg" />
                                )}
                            </button>
                        </OverlayTrigger>
                    </div>
                </div>
                <div className="d-flex justify-content-between align-items-center py-2">
                    <div>
                        <h4>Proponentes</h4>
                    </div>
                    <div>
                        <button
                            className="btn btn-success"
                            onClick={() => {
                                setShow(true);
                                setModal({
                                    Children: (
                                        <PesquisarProponentes
                                            setShow={setShow}
                                            ProponentesVendas={
                                                ProponentesVendas
                                            }
                                        />
                                    ),
                                    IconHeader: faPlus,
                                    headerComponent: "Adicionar Proponente",
                                    size: "lg",
                                });
                            }}
                        >
                            <FontAwesomeIcon icon={faPlus} /> Adicionar
                            Proponente
                        </button>
                    </div>
                </div>

                <Table
                    columns={columns}
                    data={lstProponentes ?? []}
                    keyField="ID_CONTA"
                    loading={lstProponentesLoading}
                    classes="p-3"
                    bordered={false}
                    striped
                    noSearch
                />
            </div>
            <ModalComponent
                ModalComponent={modal}
                show={show}
                setShow={setShow}
            />
        </div>
    );
}
